import React, { createContext, PureComponent } from 'react';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  isLevelZero: false,
  paymentProgressText: '',
  paymentStatusText: 'payment.paymentChoice',

  setLevelZero: () => undefined,
  setPaymentStatusText: () => undefined,
  showStatus: true,
};

export const AppTextContext = createContext<Partial<ITextContext>>(initialValue);

export class AppTextProvider extends PureComponent<IProps, Partial<ITextContext>> {
  constructor(props) {
    super(props);
    this.state = {
      isLevelZero: false,
      paymentProgressText: '',
      paymentStatusText: 'payment.paymentChoice',
      showStatus: true,
    };
  }

  setLevelZero = (isLevelZero: boolean) => {
    if (isLevelZero) {
      this.setState({ isLevelZero, paymentStatusText: 'payment.paymentChosen' });
    }
  };

  setPaymentStatusText = (paymentStatusText?: string, paymentProgressText?: string) => {
    if (!paymentProgressText) {
      this.setState({ showStatus: false });
    }
    this.setState({ paymentProgressText, paymentStatusText });
  };

  render() {
    const { Provider } = AppTextContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setLevelZero: this.setLevelZero,
          setPaymentStatusText: this.setPaymentStatusText,
        }}
      >
        {children}
      </Provider>
    );
  }
}
